import InventoryDevice from 'features/Inventories/interfaces/InventoryDevice';
import Geo from 'interfaces/SiteGeoSelection';
import {FilterParams} from '../InventoryReducer';

interface FilterDataProps {
  selectedFilters: FilterParams;
  selectedGeos: Geo[];
  deviceData: InventoryDevice[];
}

function filterData({selectedFilters, selectedGeos, deviceData}: FilterDataProps) {
  const {brand, siteType, nvsnso, storeConcept, siteStatus: status, deviceType} = selectedFilters;

  const stringSelectedGeos = selectedGeos.map(geo => geo.toString().toLowerCase());

  const filteredData = deviceData?.filter(device => {
    const geoMatch = stringSelectedGeos.includes(device.geo.toLowerCase());
    const brandMatch = brand.length === 0 || brand.includes(device.brand);
    const siteTypeMatch = siteType.length === 0 || siteType.includes(device.siteType);
    const nvsnsoMatch = nvsnso.length === 0 || nvsnso.includes(device.nvsnso);
    const conceptMatch = storeConcept.length === 0 || storeConcept.includes(device.storeConcept);
    const statusMatch = status.length === 0 || status.includes(device.siteStatus);
    const deviceTypeMatch = deviceType.length === 0 || deviceType.includes(device.deviceType);

    return (
      geoMatch &&
      brandMatch &&
      siteTypeMatch &&
      nvsnsoMatch &&
      conceptMatch &&
      statusMatch &&
      deviceTypeMatch
    );
  });

  return filteredData;
}

export default filterData;
